import { z } from "zod";

export default () => z.object({
    description: z.string().min(1),
    pipedriveCompanyName: z.string().min(1),
    contact: z.string().min(1),
    landAreaMin: z.number().nonnegative(),
    landAreaMax: z.number().nonnegative(),
    buildingAreaMin: z.number().nonnegative(),
    buildingAreaMax: z.number().nonnegative(),
});